const HARMFULL = 'HARMFULL'; 
const USEFULL = 'USEFULL';  
const CONTR = 'CONTR'; 

const PREVENT = "PREVENT"; 
const INDUCE ="INDUCE";  

export {HARMFULL , USEFULL , CONTR , PREVENT , INDUCE }; 
